module.exports = __webpack_public_path__ + "img/patent_demo_img.17659b3f.png";